// export const TokenAddress = '0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512'
// export const TheWillAddress = '0x5FbDB2315678afecb367f032d93F642f64180aa3'

export const TokenAddress = '0x7ad56BdD1d9c70C0C94cA2BF4b1397756dfbbfc8'
export const TokenAddresses = {
    Mumbai: '0x40415ea781dD3970A4f3703a6011383b7B8715Ac',
    Goerli: '0x1a53400d37D773C7A531605C268185D6e8CCaE61',
    BinanceTestnet: '0xC9AdC87b5a612F08dC04802Ca1a0C97d06365e20'
}
export const TheWillAddress = '0xc9100D772b0Ddb8D435b54cee1Fe050cf7e5789B'
export const TheWillAddresses = {
    Mumbai: '0xf79236FACf56B264a0E146a2096126C1e28D7E31',
    Polygon: '0x9be6b572afbCEBe76efC6918cd8447e90F15DC9D',
    BinanceTestnet: '0x4ad410e2d0d5508770666cd9be4e2Afa4dc912D1',
    BinanceMainnet: '0x5f94366adDAa8938441d3091D9702C99aEfA455E',
    EthereumMainnet: '0x525e51A7fbb82376277866eb5256Ed3befAE8089',
    Goerli: '0x2185Fd26af0d84D92b5b827F789Ac129BCCa342c',
    OptimismMainnet: '0xE19C894816F985A1EA6edf91b173b5fd0E82B444',
    AvalancheMainnet: '0x01201A6b62e9ea9B608bCDC400Cf32ADC9cd85Bc',
    ArbitrumMainnet: '0x9c84C93506551B9212F86c0b020c53CFFF072106'
}
export const UnlimitedAmount = '11579208923731619542357098500868790785326998466564056403945758400791312963993'
export const chainIDs = {
    Polygon: 137,
    Mumbai: 80001,
    BinanceTestnet: 97,
    BinanceMainnet: 56,
    EthereumMainnet: 1,
    Goerli: 5,
    AvalancheMainnet: 43114,
    ArbitrumMainnet: 42161,
    OptimismMainnet: 10
}
export const chainRPCURL = {
    // Polygon: 'https://polygon-mainnet.g.alchemy.com/v2/B0XeubnwCZAJmAmGXAqtYarQGn9VQL1A',
    // Polygon: 'https://polygon-mainnet.g.alchemy.com/v2/PdErp7XIFnF7-ZveImUZxGqI7zwqDvZ6',
    Polygon: 'https://polygon-rpc.com',
    Mumbai: 'https://rpc-mumbai.maticvigil.com',
    BinanceTestnet: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    BinanceMainnet: 'https://bsc-dataseed.binance.org',
    EthereumMainnet: 'https://eth-mainnet.g.alchemy.com/v2/XuX_l4hiqr_xf2CBBmdo7GMHcW0ZJ923',
    Goerli: 'https://goerli.infura.io/v3/',
    AvalancheMainnet: 'https://rpc.ankr.com/avalanche',
    ArbitrumMainnet: 'https://arb-mainnet.g.alchemy.com/v2/owpRYif1L9NLrHMysh6SPHg_c0eiCYFz',
    OptimismMainnet: 'https://opt-mainnet.g.alchemy.com/v2/r2Y15pOCmYjzWruKk2eIKmJQEz1WhvDK'
}
export const NetworkProviders = {
    Polygon: 'https://polygonscan.com',
    Mumbai: 'https://mumbai.polygonscan.com',
    BinanceTestnet: 'https://testnet.bscscan.com',
    BinanceMainnet: 'https://bscscan.com',
    EthereumMainnet: 'https://etherscan.io',
    Goerli: 'https://goerli.etherscan.io',
    AvalancheMainnet: 'https://snowtrace.io',
    ArbitrumMainnet: 'https://arbiscan.io',
    OptimismMainnet: 'https://optimistic.etherscan.io'
}
